module.exports = __webpack_public_path__ + "img/ai-task.3e4efd23.png";